export const randomElementOfArray = array =>
  array[Math.floor(Math.random() * array.length)];
